import React from 'react';
import { useScroll } from '@hooks';

const BackToTop: React.FC = () => {
  const { scrollY } = useScroll();
  const isActive = scrollY >= 50;

  const scrollToTop = (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <a
      href="#top"
      className={`back-top-btn ${isActive ? 'active' : ''}`}
      aria-label="back to top"
      onClick={scrollToTop}
      data-back-top-btn
    >
      <ion-icon name="chevron-up" aria-hidden="true"></ion-icon>
    </a>
  );
};

export default BackToTop;
